import { render } from "./App.vue?vue&type=template&id=72a5b8ea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=72a5b8ea&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__